import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const RestrictedResetRoute = ({ children }) => {
  const { resetOtpVerified, otpVerified } = useAuth();

  if (!resetOtpVerified && !otpVerified) {
    return <Navigate to="/otp" replace />;
  }

  return children;
};

export default RestrictedResetRoute;
